var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCrossRounded(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.71 4.529a.125.125 0 0 0-.126-.125l-1.031.005L7 6.26 5.448 4.41l-1.033-.004a.124.124 0 0 0-.125.125c0 .03.011.057.03.08l2.033 2.423-2.033 2.42a.125.125 0 0 0 .095.206l1.033-.004L7 7.804l1.551 1.85 1.032.005a.124.124 0 0 0 .125-.125.13.13 0 0 0-.03-.082l-2.03-2.42L9.681 4.61a.125.125 0 0 0 .028-.081Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 0a7 7 0 1 0 0 14A7 7 0 0 0 7 0Zm0 12.813A5.813 5.813 0 0 1 7 1.187a5.813 5.813 0 0 1 0 11.626Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossRounded);
export default __webpack_public_path__ + "static/media/cross-rounded.31f13c4785258c590b80b9a49e71eb9d.svg";
export { ForwardRef as ReactComponent };